import { FieldOptionBase } from 'module/api/field/types';
import { getRandomColor } from 'module/helpers/get-random-color';
import { Color } from 'module/ui/components/styles/colors';
import { useMemo, useState, useEffect } from 'react';

export interface DetailBlockField {
  label: string;
  value: string;
  color: Color;
}

export const mapDetailBlockFields = (blockFields: any[]): DetailBlockField[] =>
  blockFields
    .filter((field) => field.fieldLabel && field.fieldName)
    .map((field) => ({
      label: field.fieldLabel,
      value: field.fieldName,
      color: getRandomColor(field.fieldName),
    }));

export const constructBlockFieldsOptions = (
  selectedFields: string[],
  blockFields: DetailBlockField[],
): FieldOptionBase<any>[] => {
  return selectedFields
    .map((field) => {
      const blockField = blockFields.find(
        (blockField) => blockField.value === field,
      );

      return blockField
        ? {
            value: blockField.value,
            label: blockField.label,
            color: blockField.color,
          }
        : null;
    })
    .filter(
      (field): field is { value: string; label: string; color: Color } =>
        field !== null,
    );
};

export interface DetailBlockPromptState {
  fields: FieldOptionBase<any>[];
  title: string;
  fieldResponse?: Record<string, any>;
}

export const useAccountFields = (blockFields: any[], isLoading: boolean) => {
  return useMemo(() => {
    if (blockFields && !isLoading) {
      return mapDetailBlockFields(blockFields);
    }

    return [];
  }, [blockFields, isLoading]);
};

export const useInitialPromptFields = (
  isLoading: boolean,
  blockFields: DetailBlockField[],
  nodeFields: string[],
  prompt: DetailBlockPromptState,
  setPrompt: (prompt: DetailBlockPromptState) => void,
) => {
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    if (!isLoading && prompt.fields.length === 0 && isInitialLoad) {
      setIsInitialLoad(false);
      setPrompt({
        ...prompt,
        fields: constructBlockFieldsOptions(nodeFields, blockFields),
      });
    }
  }, [isLoading, blockFields, nodeFields, prompt, isInitialLoad, setPrompt]);
};
